import React from 'react';
import { Link } from 'react-router-dom';
import Header from './HeaderHome';
import Footer from './FooterHome';

const Certificates = () => {
    // Certificate data
    const certificates = [
        {
            id: '12a',
            icon: 'fas fa-file-alt',
            title: '12A Registration',
            subtitle: 'Income Tax Act, 1961',
            description:
                'Provisional registration granted under section 12A of the Income Tax Act.',
            regNo: 'AABTV6001BE20231',
            pdfUrl: 'assets/home_images/documents/12A.pdf',
            imgUrl: null,
        },
        {
            id: '80g',
            icon: 'fas fa-hand-holding-heart',
            title: '80G Approval',
            subtitle: 'Income Tax Act, 1961',
            description:
                'Provisional approval under section 80G of the Income Tax Act. Donors are eligible for tax exemption on contributions.',
            regNo: 'AABTV6001BF20241',
            pdfUrl: 'assets/home_images/documents/80G.pdf',
            imgUrl: null,
        },
        {
            id: 'pan',
            icon: 'fas fa-id-card',
            title: 'PAN Card',
            subtitle: 'Permanent Account Number',
            description:
                'Income Tax Department – Government of India. PAN issued to Venkatadri Seva Trust for all financial and tax-related transactions.',
            regNo: 'AABTV5311Q',
            pdfUrl: null,
            imgUrl: 'assets/home_images/documents/Venkatadri_Seva_Trust_PAN.jpeg',
        },
    ];

    return (
        <>
            <Header />

            {/* ========== HERO ========== */}
            <section className="certs-hero relative text-white py-16">
                <div className="container mx-auto px-4 text-center">
                    <div className="max-w-3xl mx-auto">
                        <h1 className="text-4xl md:text-6xl font-bold leading-tight mb-4">
                            Our Certificates &amp; Registrations
                        </h1>
                        <p className="text-xl md:text-2xl text-yellow-100/90 font-light">
                            Venkatadri Seva Trust is registered under sections 12A &amp; 80G of the Income Tax Act, 1961.
                            Committed to transparency and accountability in serving the community.
                        </p>
                        <div className="w-24 h-1 bg-yellow-300 mx-auto mt-6 rounded-full"></div>
                    </div>
                </div>
            </section>

            {/* ========== CERTIFICATES GRID ========== */}
            <section className="py-16">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-12">
                        <h2 className="text-3xl md:text-4xl font-bold text-white">Our Registrations</h2>
                        <p className="text-yellow-100 mt-2 text-lg">Click on any certificate below to view</p>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
                        {certificates.map((cert) => (
                            <div
                                key={cert.id}
                                className="cert-card bg-white rounded-xl shadow-lg overflow-hidden border-t-4 border-primary hover:shadow-2xl transition-all duration-300"
                            >
                                <div className="p-6 text-center">
                                    <div className="cert-icon">
                                        <i className={cert.icon}></i>
                                    </div>
                                    <h3 className="text-xl font-bold text-gray-800">{cert.title}</h3>
                                    <p className="text-gray-500 text-sm mt-1">{cert.subtitle}</p>
                                    <p className="text-gray-600 text-sm mt-3 leading-relaxed">{cert.description}</p>

                                    <div className="mt-4 flex flex-col gap-2">
                                        {cert.pdfUrl && (
                                            <>
                                                <a
                                                    href={cert.pdfUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="inline-flex items-center justify-center gap-2 bg-primary text-white px-5 py-2.5 rounded-lg hover:bg-primary-dark transition-smooth text-sm font-medium"
                                                >
                                                    <i className="fas fa-external-link-alt"></i> View PDF
                                                </a>

                                            </>
                                        )}
                                        {cert.imgUrl && (
                                            <>
                                                <a
                                                    href={cert.imgUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="inline-flex items-center justify-center gap-2 bg-primary text-white px-5 py-2.5 rounded-lg hover:bg-primary-dark transition-smooth text-sm font-medium"
                                                >
                                                    <i className="fas fa-external-link-alt"></i> View Image
                                                </a>

                                            </>
                                        )}
                                    </div>
                                </div>
                                {/* <div className="bg-gray-50 px-6 py-3 text-center text-xs text-gray-400 border-t border-gray-100">
                                    {cert.regNo && `Registration No: ${cert.regNo}`}
                                </div> */}
                            </div>
                        ))}
                    </div>

                    {/* Trust Badge */}
                    <div className="mt-12 max-w-3xl mx-auto bg-white/10 backdrop-blur-sm rounded-xl p-6 text-white text-center border border-white/20">
                        <p className="text-lg font-medium">
                            <i className="fas fa-shield-alt text-yellow-300 mr-2"></i>
                            All certificates are genuine and issued by the Government of India.
                        </p>
                        <p className="text-yellow-50/70 text-sm mt-2">
                            For any queries regarding our registrations, please contact us at{' '}
                            <a href="mailto:info@venkatadrisevatrust.com" className="text-yellow-300 hover:underline">
                                info@venkatadrisevatrust.com
                            </a>
                        </p>
                    </div>
                </div>
            </section>

            <Footer />

            {/* ========== INLINE STYLES (if not already in global CSS) ========== */}
            <style jsx>{`
        .certs-hero {
          background: linear-gradient(135deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 100%),
                      url('/banner/banner.png') center/cover no-repeat;
          min-height: 40vh;
        }
        .cert-icon {
          width: 72px;
          height: 72px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background: #fef3c7;
          font-size: 32px;
          margin: 0 auto 16px;
          transition: background 0.3s ease;
        }
        .cert-card:hover .cert-icon {
          background: #D97706;
        }
        .cert-card:hover .cert-icon i {
          color: white;
        }
        .cert-icon i {
          color: #D97706;
          transition: color 0.3s ease;
        }
        @media (max-width: 640px) {
          .certs-hero { min-height: 30vh; }
        }
      `}</style>
        </>
    );
};

export default Certificates;